function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.88867 14.0645C10.5732 14.0645 13.6152 11.0225 13.6152 7.33789C13.6152 3.64648 10.5664 0.604492 6.88184 0.604492C3.19727 0.604492 0.155273 3.64648 0.155273 7.33789C0.155273 11.0225 3.19727 14.0645 6.88867 14.0645ZM6.00684 10.7422C5.75391 10.7422 5.54883 10.626 5.35742 10.4004L3.49805 8.15137C3.36816 8.00098 3.30664 7.83691 3.30664 7.66602C3.30664 7.31055 3.60059 7.02344 3.94922 7.02344C4.16113 7.02344 4.33203 7.1123 4.49609 7.31055L5.98633 9.17676L8.86426 4.58984C9.02148 4.34375 9.21289 4.22754 9.43164 4.22754C9.77344 4.22754 10.0947 4.4668 10.0947 4.8291C10.0947 4.98633 10.0195 5.15039 9.92383 5.30762L6.64258 10.3867C6.48535 10.6191 6.2666 10.7422 6.00684 10.7422Z",
  fill: "#83E036"
});

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.d5662ca6.svg";
export { ForwardRef as ReactComponent };